import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import { clsx } from 'clsx';
import { type ComponentPropsWithoutRef } from 'react';

import { useDialog } from '@repo/ui/Dialog/DialogRoot';

import s from './DialogTitle.module.css';

export type DialogTitleProps = ComponentPropsWithoutRef<'h2'> & {
  as?: 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  asChild?: boolean;
  className?: string;
  position?: 'start' | 'center';
};

export const dialogTitleVariants = cva(s.title, {
  variants: {
    position: {
      start: s.startVariant,
      center: s.centerVariant,
    },
  },
});

export const DialogTitle = (props: DialogTitleProps) => {
  const {
    as = 'h2',
    asChild,
    children,
    className,
    position = 'start',
    ...attrs
  } = props;
  const { id } = useDialog();

  const Component = asChild ? Slot : as;

  return (
    <Component
      id={`${id}-title`}
      className={clsx(dialogTitleVariants({ position }), className)}
      {...attrs}
    >
      <span>{children}</span>
    </Component>
  );
};
